import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a5b5d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "byline" }
const _hoisted_4 = {
  key: 0,
  class: "author"
}
const _hoisted_5 = {
  key: 1,
  class: "separator"
}
const _hoisted_6 = {
  key: 2,
  class: "publish-date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_Markdown = _resolveComponent("Markdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "centered",
        src: _ctx.article.headlineImage
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.article.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.article.author)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "By " + _toDisplayString(_ctx.article.author), 1))
        : _createCommentVNode("", true),
      (_ctx.article.author && _ctx.article.publishTime)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "•"))
        : _createCommentVNode("", true),
      (_ctx.article.publishTime)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.article.publishTime)), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_divider),
    _createVNode(_component_Markdown, {
      style: {"margin-top":"3px"},
      class: "faded",
      source: _ctx.article.markdownContent
    }, null, 8, ["source"])
  ]))
}